import { useContext, useEffect, useMemo, useState } from 'react'
import { get, isEmpty, orderBy } from 'lodash'

import SearchComponent from 'components/common/search'
import { ActionButton } from 'components/common/buttons'
import { DropDownMenu, StatusComponent } from 'components/common/others'

import AddIcon from '@material-ui/icons/Add'
import EditOutlinedIcon from '@material-ui/icons/EditOutlined'
import FilterListOutlinedIcon from '@material-ui/icons/FilterListOutlined'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined'

import AddBranch from './AddBranch'
import AddClientCompany from './add-client-company'
import AddSites from './add-sites'
import useFetchData from 'hooks/fetch-data'
import facilities from 'Services/facilities'
import { getApplicationStorageItem } from 'helpers/getStorageItem'
import { Loader } from 'components/locations/components'
import { Toast } from 'Snackbar/useToast'
import { MainContext } from 'components/Main/provider'
import { camelizeKeys } from 'helpers/formatters'

import $ from 'jquery'
import updateActiveSiteAction from 'Actions/updateActiveSiteAction'
import updateClientCompany from 'Services/updateClientCompany'
import UpdateActiveSiteService from 'Services/UpdateActiveSiteService'
import getUserRole from 'helpers/getUserRole'
import getActiveUserSitesAndRoles from 'Services/facilities/get-usersites-roles'
import ViewBranch from './ViewBranch'
import { TablePagination } from '@material-ui/core'
import { history } from 'helpers/history'
import ViewSite from './ViewSite'
import { MinimalAutoComplete } from 'components/Assets/components'

const SitesList = () => {
  const [page, setPage] = useState(0)
  const [pageIndex, setPageIndex] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(20)
  const [searchString, setSearchString] = useState('')
  const [isOpenAddBranch, setOpenAddBranch] = useState(false)
  const [isOpenEditBranch, setOpenEditBranch] = useState(false)
  const [isOpenViewBranch, setOpenViewBranch] = useState(false)
  const [isOpenAddClientCompany, setOpenAddClientCompany] = useState(false)
  const [isOpenEditClientCompany, setOpenEditClientCompany] = useState(false)
  const [isOpenAddSite, setOpenAddSite] = useState(false)
  const [isOpenEditSite, setOpenEditSite] = useState(false)
  const [isOpenViewSite, setOpenViewSite] = useState(false)
  const [filterForColumn, setFilterForColumn] = useState(false)
  const [branchList, setBranchList] = useState([])
  const [anchorObj, setAnchorObj] = useState({})
  const [filterItem, setFilterItem] = useState({ branch: null, clientCompany: null, facility: null })

  const loginData = JSON.parse(localStorage.getItem('loginData'))
  const { setLoginSiteData, setRefetchAppMenuContext } = useContext(MainContext)
  const checkUserRole = new getUserRole()

  const formatStateData = d => {
    let sortedList = []
    if (!isEmpty(d)) {
      sortedList = d.map(item => ({
        ...item,
        label: item.stateName,
        value: item.stateId,
      }))
    }
    return sortedList
  }

  const {
    loading: branchLoading,
    data: branchData,
    reFetch,
  } = useFetchData({ fetch: facilities.branch.get, payload: { companyId: getApplicationStorageItem('companyId'), pageindex: pageIndex, pagesize: rowsPerPage, searchString: isEmpty(searchString) ? null : searchString, companybranchId: get(filterItem, 'branch.value', null) }, formatter: d => get(d, 'data', []), defaultValue: [] })
  const { loading: branchAllLoading, data: branchAllData } = useFetchData({ fetch: facilities.branch.get, payload: { companyId: getApplicationStorageItem('companyId'), pageindex: 0, pagesize: 0, searchString: null }, formatter: d => get(d, 'data', []), defaultValue: [] })
  const { loading: stateLoading, data: stateData } = useFetchData({ fetch: facilities.getAllStateList, payload: { searchString: null }, formatter: d => formatStateData(get(d, 'data.stateList', [])), defaultValue: [] })

  const {
    loading: companyLoading,
    data: clientCompanies,
    reFetch: callClientCompanies,
  } = useFetchData({
    fetch: facilities.company.getAllClientCompanyListForUser,
    formatter: d => get(d, 'data.list', []),
    defaultValue: [],
  })

  const {
    loading: bcsLoading,
    data: bcsData,
    reFetch: getAllBCS,
  } = useFetchData({
    fetch: facilities.getAllBranchWithClientCompanyAndSites,
    formatter: d => get(d, 'data', []),
  })

  const dropDownMenuOptions = [
    {
      id: 1,
      type: 'button',
      text: 'Branch',
      onClick: () => setOpenAddBranch(true),
      show: checkUserRole.isCompanyAdmin() || checkUserRole.isSuperAdmin(),
    },
    {
      id: 2,
      type: 'button',
      text: 'Client Company',
      onClick: () => setOpenAddClientCompany(true),
      show: true,
    },
    {
      id: 3,
      type: 'button',
      text: 'Facility',
      onClick: () => setOpenAddSite(true),
      show: true,
    },
  ]

  useEffect(() => {
    if (!isEmpty(get(branchData, 'list', []))) setBranchList(get(branchData, 'list', []))
  }, [branchData])

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
    setPageIndex(newPage + 1)
  }

  const handleChangeRowsPerPage = event => {
    setBranchList([])
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
    setPageIndex(1)
  }

  const postSearch = () => {
    setBranchList([])
    setPage(0)
    setPageIndex(1)
  }

  const handleExpand = async (e, data) => {
    e.stopPropagation()
    try {
      if (!isEmpty(data.companies)) return updateCompanies(data, false, !data.isExpanded, data.companies)
      updateCompanies(data, true)
      const res = await facilities.company.get({ companyId: getApplicationStorageItem('companyId'), pageindex: 0, pagesize: 0, searchString: isEmpty(searchString) ? null : searchString, companybranchId: data?.companybranchId })
      if (res.success) {
        const companies = orderBy(
          get(res, 'data.list', []).map(d => ({ ...d, name: d.clientCompanyName })),
          [d => d.name && d.name.toLowerCase()],
          ['asc']
        )
        updateCompanies(data, false, true, companies)
      } else throw new Error()
    } catch (error) {
      updateCompanies(data, false, false, [])
      Toast.error(`Error fetching companies. Please try again !`)
    }
  }

  const updateCompanies = (branch, isLoading, isExpanded, companies) => {
    const updatedBranchData = branchList.map(item => {
      if (item.companybranchId === branch.companybranchId) {
        return {
          ...item,
          isExpanded: isExpanded,
          loading: isLoading,
          companies: companies || [],
        }
      }
      return item
    })
    setBranchList(updatedBranchData)
  }

  const handleCompanyExpand = async (e, branch, company) => {
    e.stopPropagation()
    const updatedBranchData = branchList.map(item => {
      if (item.companybranchId === branch.companybranchId) {
        const updatedCompany = item.companies.map(comp => {
          if (comp.clientCompanyId === company.clientCompanyId) {
            return {
              ...comp,
              isExpanded: !comp.isExpanded,
            }
          }
          return comp
        })
        return {
          ...item,
          companies: updatedCompany,
        }
      }
      return item
    })
    setBranchList(updatedBranchData)
  }

  const editBranch = (e, data) => {
    e.stopPropagation()
    setAnchorObj(data)
    setOpenEditBranch(true)
  }

  const viewBranch = (e, data) => {
    e.stopPropagation()
    setAnchorObj(data)
    setOpenViewBranch(true)
  }

  const editCompany = (e, data, id) => {
    e.stopPropagation()
    setAnchorObj({ ...data, branchId: id })
    setOpenEditClientCompany(true)
  }

  const editSite = (e, data, id) => {
    e.stopPropagation()
    setAnchorObj({ ...data, activeCompanyId: id })
    setOpenEditSite(true)
  }

  const handleCompanyClick = (e, id, companybranchId) => {
    e.stopPropagation()
    history.push({ pathname: `/facilities/details/${id}`, search: `?companybranchId=${companybranchId}`, state: { pageRows: rowsPerPage, search: searchString, pageIndex } })
  }

  const handleSiteViewBtn = (e, data) => {
    e.stopPropagation()
    setAnchorObj(data)
    setOpenViewSite(true)
  }

  // change site
  const handleSiteRadioClick = ({ siteId, siteName }, accessibleSites) => {
    $('#pageLoading').show()
    updateActiveSiteAction({ site_id: siteId })
      .then(response => {
        localStorage.setItem('siteId', siteId)
        localStorage.setItem('siteName', siteName)
        sessionStorage.setItem('siteId', siteId)
        sessionStorage.setItem('siteName', siteName)
        setLoginSiteData(prevState => ({
          ...prevState,
          siteName: siteName,
          activeSiteId: siteId,
          accessibleSites,
        }))
        $('#pageLoading').hide()
        Toast.success(' The current site is inactive and has been changed. You will be redirected to an active site.')
      })
      .catch(error => {
        $('#pageLoading').hide()
        Toast.error(error.tostMsg.msg)
      })
  }

  // change compnay
  const changeClientCompany = async comp => {
    $('#pageLoading').show()
    try {
      const { siteId, siteName } = comp.clientCompanyUsersites[0]
      const cc = await updateClientCompany({ company_id: comp.clientCompanyId, site_id: siteId })
      const ac = await UpdateActiveSiteService({ site_id: siteId })

      Toast.success('The current client company is inactive and has been changed. You will be redirected to an active client company.')

      setLoginSiteData(prevState => ({
        ...prevState,
        accessibleSites: comp.clientCompanyUsersites,
        activeClientCompanyId: comp.clientCompanyId,
        clientCompanyName: comp.clientCompanyName,
        siteName: siteName,
      }))

      localStorage.setItem('clientCompanyName', comp.clientCompanyName)
      localStorage.setItem('siteId', siteId)
      localStorage.setItem('siteName', siteName)
      localStorage.setItem('activeClientCompanyId', comp.clientCompanyId)
      sessionStorage.setItem('clientCompanyName', comp.clientCompanyName)
      sessionStorage.setItem('siteId', siteId)
      sessionStorage.setItem('siteName', siteName)
      sessionStorage.setItem('activeClientCompanyId', comp.clientCompanyId)
    } catch (error) {
      console.log(error)
      Toast.error('Something went wrong!')
    }
    $('#pageLoading').hide()
  }

  const reFetchFacilityData = async type => {
    if (type === 1) reFetch()
    callClientCompanies()
    getAllBCS()
    if (checkUserRole.isSuperAdmin()) {
      setRefetchAppMenuContext(true)
      localStorage.setItem('headerDataUpdate', Date.now())
    } else {
      await getUserFacilitiesData()
    }
  }

  const getUserFacilitiesData = async () => {
    try {
      const res = await getActiveUserSitesAndRoles(get(loginData, 'uuid', ''))
      if (res.success > 0) {
        const data = camelizeKeys(res.data)
        const clientCompany = get(data, 'clientCompany', []).find(d => d.clientCompanyId === getApplicationStorageItem('activeClientCompanyId'))
        const clientCompanyUsersites = !isEmpty(clientCompany) > 0 ? clientCompany.clientCompanyUsersites : []
        const currentActiveSite = clientCompanyUsersites.find(e => e.siteId === getApplicationStorageItem('siteId'))

        setLoginSiteData(prevState => {
          const updatedLoginSiteData = {
            ...prevState,
            defaultSiteName: get(data, 'defaultSiteName', ''),
            companyName: get(prevState, 'companyName', localStorage.getItem('companyName')),
            defaultCompanyName: get(prevState, 'defaultCompanyName', localStorage.getItem('defaultCompanyName')),
            userroles: get(data, 'userroles', []),
            client_company: get(data, 'clientCompany', []),
            accessibleSites: clientCompanyUsersites,
            activeClientCompanyId: get(clientCompany, 'clientCompanyId', prevState.activeClientCompanyId),
            clientCompanyName: get(clientCompany, 'clientCompanyName', prevState.clientCompanyName),
            activeSiteId: get(currentActiveSite, 'siteId', prevState.activeSiteId),
            siteName: get(currentActiveSite, 'siteName', prevState.siteName),
          }

          // // Update session storage
          Object.keys(updatedLoginSiteData).forEach(key => {
            sessionStorage.setItem(key, JSON.stringify(updatedLoginSiteData[key]))
          })
          sessionStorage.setItem('siteId', get(currentActiveSite, 'siteId', prevState.activeSiteId))
          //need to update localstorage as well due to when do open in new tab its taking new context state which will default take from localstorage
          localStorage.setItem('clientCompanyName', get(clientCompany, 'clientCompanyName', prevState.clientCompanyName))
          localStorage.setItem('activeClientCompanyId', get(clientCompany, 'clientCompanyId', prevState.activeClientCompanyId))
          localStorage.setItem('siteId', get(currentActiveSite, 'siteId', prevState.activeSiteId))
          localStorage.setItem('siteName', get(currentActiveSite, 'siteName', prevState.siteName))

          if (!isEmpty(clientCompanyUsersites) && !clientCompanyUsersites.some(e => e.siteId === updatedLoginSiteData.activeSiteId)) {
            handleSiteRadioClick(clientCompanyUsersites[0], clientCompanyUsersites)
          }
          if (isEmpty(clientCompany)) {
            changeClientCompany(get(data, 'clientCompany', [])[0])
          }

          if (!isEmpty(get(res, 'data.client_company', [])) || !isEmpty(get(res, 'data.usersites', []))) {
            // console.log('client company data - ', get(res, 'data.client_company', []))
            // console.log('site data - ', get(res, 'data.usersites', []))
            const loginData = JSON.parse(localStorage.getItem('loginData'))
            const updatedLoginData = {
              ...loginData,
            }
            if (!isEmpty(get(res, 'data.client_company', []))) {
              updatedLoginData.client_company = get(res, 'data.client_company', [])
            }
            if (!isEmpty(get(res, 'data.usersites', []))) {
              updatedLoginData.usersites = get(res, 'data.usersites', [])
            }
            localStorage.setItem('loginData', JSON.stringify(updatedLoginData))
          }
          localStorage.setItem('headerDataUpdate', Date.now())

          return updatedLoginSiteData
        })
      } else {
        Toast.error(res.message)
      }
    } catch (error) {
      console.log('error - ', error)
      Toast.error('Something went wrong !')
    }
  }

  const clickOnHeaderCell = e => {
    e.stopPropagation()
    if (filterForColumn) setFilterItem({ branch: null, clientCompany: null, facility: null })
    setFilterForColumn(!filterForColumn)
  }

  const handleFilterChange = (key, data) => {
    let updatedFilter = { ...filterItem }
    if (key === 'facility' && data) {
      const branch = branchOptions.find(item => item.value === data?.companybranchId)
      const company = companyOptions.find(item => item.value === data?.clientCompanyId)
      updatedFilter = { ...updatedFilter, ['branch']: branch, ['clientCompany']: company }
    } else if (key === 'clientCompany' && data) {
      const branch = branchOptions.find(item => item.value === data?.companybranchId)
      updatedFilter = { ...updatedFilter, ['branch']: branch }
    }

    setFilterItem(prevState => {
      updatedFilter = { ...updatedFilter, [key]: data }
      return updatedFilter
    })
  }

  const branchOptions = useMemo(() => {
    let sortedList = []
    if (!isEmpty(bcsData?.companyBranchList)) {
      sortedList = bcsData?.companyBranchList.map(item => ({
        label: item.companyBranchName,
        value: item.companybranchId,
      }))
    }
    return orderBy(sortedList, [item => item.label.toLowerCase()], ['asc'])
  }, [bcsData])

  const companyOptions = useMemo(() => {
    let sortedList = []
    if (!isEmpty(bcsData?.clientCompanyList)) {
      sortedList = bcsData?.clientCompanyList.map(item => ({
        ...item,
        label: item.clientCompanyName,
        value: item.clientCompanyId,
      }))
    }
    return orderBy(sortedList, [item => item.label.toLowerCase()], ['asc'])
  }, [bcsData])

  const facilityOptions = useMemo(() => {
    let sortedList = []
    if (!isEmpty(bcsData.siteList)) {
      sortedList = bcsData?.siteList.map(item => ({
        ...item,
        label: item.siteName,
        value: item.siteId,
      }))
    }
    return orderBy(sortedList, [item => item.label.toLowerCase()], ['asc'])
  }, [bcsData])

  return (
    <div style={{ height: 'calc(100vh - 128px)', padding: '20px', background: '#fff' }}>
      <div className='d-flex flex-row justify-content-between align-items-center mb-3' style={{ width: '100%' }}>
        <DropDownMenu dropDownMenuOptions={dropDownMenuOptions} startIcon={<AddIcon />} btnText='Create' />
        <div className='d-flex flex-row align-items-center'>
          <SearchComponent postClear={postSearch} postSearch={postSearch} setSearchString={setSearchString} />
          <div className='mx-2'>
            <ActionButton action={clickOnHeaderCell} icon={<FilterListOutlinedIcon fontSize='small' />} tooltip='' style={{ padding: '6px', color: 'white', backgroundColor: '#778899', borderRadius: '4px' }} />
          </div>
        </div>
      </div>
      {filterForColumn && (
        <div className='d-flex flex-wrap mt-2 mb-3' style={{ backgroundColor: '#fafafa', padding: '16px', borderRadius: '4px', gap: '5px' }}>
          <MinimalAutoComplete isLoading={bcsLoading} w={25} value={filterItem?.branch} placeholder='Select Branch' label='Branch' isClearable baseStyles={{ zIndex: '7' }} options={branchOptions} onChange={val => handleFilterChange('branch', val)} />
          <MinimalAutoComplete isLoading={bcsLoading} w={25} value={filterItem?.clientCompany} placeholder='Select Client Company' label='Client Company' options={companyOptions} isClearable baseStyles={{ zIndex: '6' }} onChange={val => handleFilterChange('clientCompany', val)} />
          <MinimalAutoComplete isLoading={bcsLoading} w={25} value={filterItem?.facility} options={facilityOptions} placeholder='Select Facility' label='Facility' isClearable baseStyles={{ zIndex: '6' }} onChange={val => handleFilterChange('facility', val)} />
        </div>
      )}
      <div className='table-responsive dashboardtblScroll' id='style-1' style={{ maxHeight: 'calc(100vh - 255px)', height: 'calc(100vh - 255px)' }}>
        {branchLoading || branchAllLoading ? (
          <Loader />
        ) : isEmpty(branchList) ? (
          <div className='Pendingtbl-no-datafound' style={{ marginTop: '20px', textAlign: 'center' }}>
            No data found !
          </div>
        ) : (
          <div>
            <div className='border-bottom py-1' style={{ display: 'grid', gridTemplateColumns: 'auto 600px 100px' }}>
              <div className='text-bold pl-2'>Branch Name</div>
              <div className='text-bold'>Company Count</div>
              <div className='text-bold'>Actions</div>
            </div>
            {branchList.map((branch, index) => (
              <div key={branch.companybranchId} style={{ width: '100%', marginLeft: 0 }}>
                <div onClick={e => viewBranch(e, branch)} className={`${!branch?.isExpanded ? 'border-bottom' : ''} py-1 align-items-center`} style={{ display: 'grid', gridTemplateColumns: 'auto 600px 100px', cursor: 'pointer' }}>
                  <div className='d-flex align-items-center text-align-center'>
                    {branch?.isExpanded ? (
                      <ActionButton hide={!isEmpty(branch.companyBranchName) && isEmpty(branch?.companies)} action={e => handleExpand(e, branch)} tooltip='COLLAPSE' icon={<ExpandMoreIcon fontSize='small' />} />
                    ) : (
                      <ActionButton hide={get(branch, 'totalClientCompanyCount', 0) === 0} isLoading={branch?.loading} action={e => handleExpand(e, branch)} tooltip='EXPAND' icon={<ChevronRightIcon fontSize='small' />} />
                    )}
                    <div className='text-xs'>{branch.companyBranchName}</div>
                  </div>
                  <div className='text-xs'>{get(branch, 'totalClientCompanyCount', 0)}</div>
                  {checkUserRole.isCompanyAdmin() || checkUserRole.isSuperAdmin() ? (
                    <div className='d-flex align-items-center'>
                      <ActionButton tooltip='EDIT' action={e => editBranch(e, branch)} icon={<EditOutlinedIcon fontSize='small' />} />
                    </div>
                  ) : (
                    <div className='d-flex align-items-center'>
                      <ActionButton tooltip='VIEW' action={e => viewBranch(e, branch)} icon={<VisibilityOutlinedIcon fontSize='small' />} />
                    </div>
                  )}
                </div>
                {branch?.isExpanded && (
                  <>
                    <div className='text-bold' style={{ paddingLeft: '45px', marginTop: '6px' }}>
                      Client Companies
                    </div>
                    <div className='py-1 align-items-center' style={{ display: 'grid', gridTemplateColumns: 'auto 600px 100px', paddingLeft: '37px', height: '43px' }}>
                      <div className='text-bold ml-2 border-bottom '>Company Name</div>
                      <div className='text-bold border-bottom '>Facility Count</div>
                      <div className='text-bold border-bottom '>Actions</div>
                    </div>
                    {get(branch, 'companies', [])
                      .filter(company => {
                        if (filterItem.clientCompany) {
                          return company.clientCompanyId === filterItem.clientCompany.value
                        }
                        return true
                      })
                      .map(company => (
                        <div key={company.clientCompanyId} onClick={e => handleCompanyClick(e, company?.clientCompanyId, branch.companybranchId)} style={{ width: 'calc(100% - 40px)', marginLeft: '40px' }}>
                          <div className={`${!company?.isExpanded ? 'border-bottom' : ''} py-1 align-items-center`} style={{ display: 'grid', gridTemplateColumns: 'auto 600px 100px', cursor: 'pointer' }}>
                            <div className='d-flex align-items-center text-align-center'>
                              {company?.isExpanded ? (
                                <ActionButton hide={!isEmpty(company.clientCompanyName) && isEmpty(company?.listOfSite)} action={e => handleCompanyExpand(e, branch, company)} tooltip='COLLAPSE' icon={<ExpandMoreIcon fontSize='small' />} />
                              ) : (
                                <ActionButton hide={get(company, 'listOfSite', []).length === 0} isLoading={false} action={e => handleCompanyExpand(e, branch, company)} tooltip='EXPAND' icon={<ChevronRightIcon fontSize='small' />} />
                              )}
                              <div className='text-xs'>{company.clientCompanyName}</div>
                            </div>
                            <div className='text-xs'>{get(company, 'listOfSite', []).length}</div>
                            <div className='d-flex align-items-center'>
                              <ActionButton tooltip='EDIT' action={e => editCompany(e, company, branch.companybranchId)} icon={<EditOutlinedIcon fontSize='small' />} />
                            </div>
                          </div>
                          {company?.isExpanded && (
                            <>
                              <div className='text-bold' style={{ paddingLeft: '45px', marginTop: '6px' }}>
                                Facilities
                              </div>
                              <div className='py-1 align-items-center' style={{ display: 'grid', gridTemplateColumns: 'auto 600px 100px', paddingLeft: '37px', height: '43px' }}>
                                <div className='text-bold ml-2 border-bottom '>Facility Name</div>
                                <div className='text-bold border-bottom '>Facility Contacts</div>
                                <div className='text-bold border-bottom '>Actions</div>
                              </div>
                              {get(company, 'listOfSite', [])
                                .filter(site => {
                                  if (filterItem.facility) {
                                    return site.siteId === filterItem.facility.value
                                  }
                                  return true
                                })
                                .map(site => (
                                  <div key={site.siteId} onClick={e => handleSiteViewBtn(e, site)} style={{ width: 'calc(100% - 40px)', marginLeft: '40px' }}>
                                    <div className='border-bottom py-1 align-items-center' style={{ display: 'grid', gridTemplateColumns: 'auto 600px 100px', cursor: 'pointer' }}>
                                      <div className='text-xs ml-2'>{site.siteName}</div>
                                      <div className='text-xs'>{get(site, 'sitecontactData.sitecontactName', 'N/A') !== 'N/A' ? <StatusComponent color='#848484' label={get(site, 'sitecontactData.sitecontactName')} size='medium' /> : 'N/A'}</div>
                                      <div className='d-flex align-items-center'>
                                        <ActionButton tooltip='EDIT' action={e => editSite(e, site, company.clientCompanyId)} icon={<EditOutlinedIcon fontSize='small' />} />
                                      </div>
                                    </div>
                                  </div>
                                ))}
                            </>
                          )}
                        </div>
                      ))}
                  </>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {!isEmpty(get(branchData, 'list', [])) && <TablePagination rowsPerPageOptions={[20, 40, 60, 80, 100]} component='div' count={get(branchData, 'listsize', [])} rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} />}
      {isOpenAddBranch && <AddBranch open={isOpenAddBranch} onClose={() => setOpenAddBranch(false)} reFetch={() => reFetchFacilityData(1)} />}
      {isOpenEditBranch && <AddBranch open={isOpenEditBranch} onClose={() => setOpenEditBranch(false)} reFetch={() => reFetchFacilityData(1)} isEdit anchorObj={anchorObj} />}
      {isOpenViewBranch && <ViewBranch open={isOpenViewBranch} onClose={() => setOpenViewBranch(false)} anchorObj={anchorObj} />}

      {isOpenAddClientCompany && <AddClientCompany open={isOpenAddClientCompany} onClose={() => setOpenAddClientCompany(false)} reFetch={() => reFetchFacilityData(1)} stateData={stateData} branchData={get(branchAllData, 'list', [])} />}
      {isOpenEditClientCompany && <AddClientCompany open={isOpenEditClientCompany} onClose={() => setOpenEditClientCompany(false)} reFetch={() => reFetchFacilityData(1)} isEdit anchorObj={anchorObj} stateData={stateData} clientBranchId={anchorObj?.branchId} branchData={get(branchAllData, 'list', [])} />}

      {isOpenAddSite && <AddSites open={isOpenAddSite} onClose={() => setOpenAddSite(false)} reFetch={() => reFetchFacilityData(1)} stateData={stateData} clientCompanies={clientCompanies.filter(item => item?.status === 1)} />}
      {isOpenEditSite && <AddSites open={isOpenEditSite} onClose={() => setOpenEditSite(false)} reFetch={() => reFetchFacilityData(1)} anchorObj={anchorObj} clientCompanyId={anchorObj?.activeCompanyId} isEdit stateData={stateData} clientCompanies={clientCompanies.filter(item => item?.status === 1)} />}
      {isOpenViewSite && <ViewSite open={isOpenViewSite} onClose={() => setOpenViewSite(false)} siteDetails={anchorObj} />}
    </div>
  )
}

export default SitesList
